import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取ISF客户，根据客户id
export function getISFPassengersAll(params) {
  return request({
    url: URL.booking.isfPassenger.getISFPassengersAll,
    method: 'get',
    params
  })
}

// 获取ISF客户，根据客户id
export function getISFPassengersList(params) {
  return request({
    url: URL.booking.isfPassenger.getISFPassengersList,
    method: 'get',
    params
  })
}
